import React from 'react';

import '../styles/Footer.css';
import { node } from 'prop-types';

export default function Footer({ children }) {
    return (<footer>
        <div
            className={'footer-section'}>
            {children}
        </div>
    </footer>);
}

Footer.propTypes = {
    children: node,
};